var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7743 8.79736L14.5299 12.5414C14.6116 12.6231 14.6196 12.7476 14.5476 12.8196L13.2454 14.1174C13.1734 14.1894 13.049 14.1814 12.9663 14.0996L9.21875 10.3636",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21065 9.6897C4.05954 9.6897 2.31642 7.95104 2.31642 5.80704C2.31642 3.66215 4.05954 1.92348 6.21065 1.92348C8.36176 1.92348 10.1049 3.66215 10.1049 5.80704C10.1049 7.95193 8.36176 9.6897 6.21065 9.6897ZM6.21065 0.0585938C3.02665 0.0585938 0.445312 2.63193 0.445312 5.80704C0.445312 8.98215 3.02665 11.5555 6.21065 11.5555C9.39465 11.5555 11.976 8.98215 11.976 5.80704C11.976 2.63193 9.39465 0.0585938 6.21065 0.0585938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.45a0361bc865e7fae4e6c58ce2b05167.svg";
export { ForwardRef as ReactComponent };